import {
  Modal as MUIModal,
  Typography,
  Button,
  Box,
  Stack,
} from "@mui/material";
import { ModalCloseIcon, SomethingWentWrongIcon } from "../../@lib/icons";
import { useLanguageTranslator } from "../useLanguageContext";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 530,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  py: 3,
  px: 1,
};

function ErrorModal({ isOpen, handleClose }: any) {
  const { translator } = useLanguageTranslator();
  return (
    <div>
      <MUIModal
        open={isOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack
            sx={{ display: "flex", justifyContent: "end", alignItems: "end" }}
          >
            <Button
              onClick={handleClose}
              sx={{ padding: "0px", minWidth: "auto" }}
            >
              <ModalCloseIcon />
            </Button>
          </Stack>
          <Stack
            direction="column"
            sx={{ padding: "10px 60px" }}
            alignItems="center"
          >
            <SomethingWentWrongIcon />
            <Typography id="modal-modal-title" sx={{ fontSize: "16px" }}>
              Something went wrong .
            </Typography>
            <Typography
              id="modal-modal-description"
              variant="h6"
              component="h2"
              sx={{ fontSize: "16px" }}
            >
              We are already working to fix this
            </Typography>
            <Stack direction="row" justifyContent="center" gap={1} mt={2}>
              <Button
                onClick={handleClose}
                sx={{
                  backgroundColor: "#F6A000",
                  color: "white",
                  padding: "7px 50px",
                }}
              >
                {translator("generic.Close")}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </MUIModal>
    </div>
  );
}

export { ErrorModal };
